import { useLocation, Navigate, useLoaderData } from 'react-router-dom';

export default function RequireAuth({ children }) {
    const {
        user,
      // TODO display error
        // error,
    } = useLoaderData();
    const location = useLocation();
    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
}